// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link {
  text-decoration: underline !important;
  text-decoration-color: #023b72 !important;
  color: #023b72 !important;
  cursor: pointer;
}

.property {
  text-decoration: underline;
}

.value {
  margin-left: 10px;
  word-break: break-all;
}

.statusNew {
  background: #ef8293;
  border-radius: 10%;
}

.statusPending {
  background: #e6ff47;
  border-radius: 10%;
}

.statusvalidated {
  background: #efc480;
  border-radius: 10%;
}

.statussigned {
  background: #a6f979;
  border-radius: 10%;
}

.important {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/shared/components/display-infos-document/display-infos-document.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,yCAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,iBAAA;EACA,qBAAA;AACF;;AACA;EACE,mBAAA;EAEA,kBAAA;AACF;;AACA;EACE,mBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,mBAAA;EACA,kBAAA;AAGF;;AADA;EACE,mBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,iBAAA;AAKF","sourcesContent":[".link {\r\n  text-decoration: underline !important;\r\n  text-decoration-color: #023b72 !important;\r\n  color: #023b72 !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.property {\r\n  text-decoration: underline;\r\n}\r\n\r\n.value {\r\n  margin-left: 10px;\r\n  word-break: break-all;\r\n}\r\n.statusNew{\r\n  background: #ef8293;\r\n\r\n  border-radius: 10%;\r\n}\r\n.statusPending{\r\n  background: #e6ff47;\r\n  border-radius: 10%;\r\n}\r\n.statusvalidated{\r\n  background: #efc480;\r\n  border-radius: 10%;\r\n}\r\n.statussigned{\r\n  background: #a6f979;\r\n  border-radius: 10%;\r\n}\r\n.important {\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
